export default __webpack_public_path__ + "media/AppsMirror.f545d0948324b9dcdc6b879be6c646e4.svg";